import {v4 as uuidv4} from 'uuid';

import img1 from '../../assets/img/members/SOMA - MEMBERSHIP CERTIFICATE (2).jpg';
import img2 from '../../assets/img/members/TEXPROCIL.jpg';
import img3 from '../../assets/img/members/TEXPROCIL - MEMBERSHIP CERTIFICATE.jpg';
import img4 from '../../assets/img/members/CAI - MEMBERSHIP CERTIFICATE.jpg';



const MembershipsData = [
    {
        id: uuidv4(),
        img: img1,
     
    },

    {
        id: uuidv4(),
        img: img2,
        
        
    },

    {
        id: uuidv4(),
        img: img3,
      
   
    },

    {
        id: uuidv4(),
        img: img4,
       
    }
 

]

export default MembershipsData;